<template>
<!--  ms="6" md="3" class="mt-5"-->
  <b-col sm="8" md="6" lg="4" xl="3" class="mt-5">

    <b-card
        tag="article"
        class="h-100 p-0 shadow card-gray-light"
        :img-src="require('../../../../../assets/card-empleo.jpg')"
    >
      <a :href="'/ver/empleo/' + this.empleo.url_public"
         target="_blank"
         class="text-decoration-none">


        <b-card-text class="mt-3">
          <h5 class="font-orange font-weight-bold">
            <i class="fas fa-medal"></i>
            {{ empleo.percentage + '% Match' }}<br>
          </h5>

          <h5 class="font-blue mt-3 mb-2 font-weight-bold text-left">
            {{ empleo.titulo }}
          </h5>
          <p class="font-blue font-weight-bold">
            <i class="far fa-calendar-alt"/>
            {{ empleo.tipo_empleo }}
            <br>
            <i class="fa fa-location-arrow" aria-hidden="true"></i>
            {{ empleo.ubicacion }}
            <br>
            <small class="my-2 font-weight-light font-gray-dark">
              {{ empleo.created_at | moment('DD MMMM YYYY') }}
            </small>
          </p>


        </b-card-text>

      </a>
    </b-card>
  </b-col>

</template>
<script>
export default {
  name: "JobRecomendation",
  props: {
    empleo: {
      type: Object,
      required: true,
    }
  },
  methods: {
    verEmpleo() {
      this.$router.push({
        name: 'job-view',
        params: {
          url_public: this.empleo.enterprise.url_public,
          url_job: this.empleo.url_public
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card-gray-light {
  background: #fbfbfb;
}

.add-padding {
  padding-top: 1.5rem;
  padding-right: .5rem;
  padding-bottom: 1.5rem;
  padding-left: .5rem;
}

.box {
  width: 104px;
  height: 80px;
  background: #CCC;
  overflow: hidden;
}

.box img {
  width: 100%;
  height: auto;
}

@supports (object-fit: cover) {
  .box img {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/#public/job/components/home/JobRecomendation.vue